import { render, staticRenderFns } from "./card.md?vue&type=template&id=49b66d84&"
import script from "./card.md?vue&type=script&lang=js&"
export * from "./card.md?vue&type=script&lang=js&"
import style0 from "./card.md?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports